const FLAG = '__TEE_TIME_REFRESH_BLOCKED__';
function getStore() {
    try {
        return globalThis;
    }
    catch {
        return {};
    }
}
export function isRefreshBlocked() {
    const store = getStore();
    return Boolean(store[FLAG]);
}
export function blockRefresh() {
    const store = getStore();
    store[FLAG] = true;
}
export function resetRefreshBlock() {
    const store = getStore();
    store[FLAG] = false;
}
//# sourceMappingURL=refresh-guard.js.map